import { INSPECTION_TYPE_BAR_CLASS } from '@/constants/inspection-type-chart-colors'
import { cn } from '@/lib/utils'
import type { CommitmentMatrixDashboardOutput } from '@/types'
import { formatPercentage } from '@/utils/format-percentage'

const INSPECTION_KPI_STYLE = {
	vereAgir: {
		text: 'text-kaefer-forest-green',
		bar: INSPECTION_TYPE_BAR_CLASS['see-act'],
	},
	direcionada: {
		text: 'text-kaefer-ocean-blue',
		bar: INSPECTION_TYPE_BAR_CLASS.directed,
	},
	interacao: {
		text: 'text-kaefer-violet',
		bar: INSPECTION_TYPE_BAR_CLASS.interaction,
	},
	cartaoAmarelo: {
		text: 'text-kaefer-dark-grey',
		bar: INSPECTION_TYPE_BAR_CLASS['yellow-card'],
	},
	total: {
		text: 'text-kaefer-dark-grey',
		bar: 'bg-kaefer-medium-grey',
	},
} as const

interface KpiCardsProps {
	metrics: CommitmentMatrixDashboardOutput['metrics']
}

export function KpiCards({ metrics }: KpiCardsProps) {
	return (
		<div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-7">
			<KpiCard
				label="Ver & Agir"
				value={metrics.totalVereAgirCount}
				style={INSPECTION_KPI_STYLE.vereAgir}
			/>
			<KpiCard
				label="Direcionadas"
				value={metrics.totalDirecionadaCount}
				style={INSPECTION_KPI_STYLE.direcionada}
			/>
			<KpiCard
				label="Interações"
				value={metrics.totalInteracaoCount}
				style={INSPECTION_KPI_STYLE.interacao}
			/>
			<KpiCard
				label="Inspeções totais"
				value={metrics.totalDoneInspections}
				style={INSPECTION_KPI_STYLE.total}
			/>
			<KpiCard label="Meta total" value={metrics.totalTargetInspections} />
			<KpiCard
				label="Aderência geral"
				value={formatPercentage(metrics.completionPct)}
			/>
		</div>
	)
}

function KpiCard({
	label,
	value,
	style,
}: {
	label: string
	value: string | number
	style?: { text: string; bar: string }
}) {
	return (
		<div className="rounded-lg border border-kaefer-light-silver bg-white p-4 text-center">
			<p
				className={cn(
					'text-xl font-bold',
					style ? style.text : 'text-kaefer-dark-grey',
				)}
			>
				{value}
			</p>
			<p className="mt-1 text-[11px] text-muted-foreground">{label}</p>
			{style && (
				<div className={cn('mx-auto mb-2 h-1 w-8 rounded-full', style.bar)} />
			)}
		</div>
	)
}
